import { render, staticRenderFns } from "./VisualizarUnidadeTematicaDialog.vue?vue&type=template&id=40848ee3"
import script from "./VisualizarUnidadeTematicaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarUnidadeTematicaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports